import { ErrorMachineName } from '../enums';

export const errors: Record<ErrorMachineName, string> = {
  [ErrorMachineName.InvalidCredentials]: 'Неверный email или пароль',
  [ErrorMachineName.EmailInUse]: 'Данный email уже используется',
  [ErrorMachineName.UserNotFound]: 'Данный пользователь не найден',
  [ErrorMachineName.ConfirmationCodeNotFound]: 'Код подтвержения не найден',
  [ErrorMachineName.ConfirmationCodeExpired]: 'Срок кода подтвержения истек',
};
